import { createCrudActions } from '../utils/crudGenerator';

const formatWorkorders = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.name}`,
        value: item._id,
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchWorkorders,
    create: createWorkorder,
    update: updateWorkorder,
    delete: deleteWorkorders
} = createCrudActions('WORKORDER', "Parte de trabajo", formatWorkorders);

// Función específica para finalizar un workorder
export const finishWorkorder = (workorderId) => async (dispatch) => {
    return dispatch(updateWorkorder({ ...workorderId, finished: true }));
};